import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { NewsComplaintState } from './news-complaint.state';
import { NewsComplaintStateActions } from './news-complaint.state.actions';

@Injectable({ providedIn: 'root' })
export class NewsComplaintStateService {
  private readonly store = inject(Store);

  newCount$ = this.store.select(NewsComplaintState.newCount);

  public init(): void {
    this.loadNewCount();
  }

  public loadNewCount(): void {
    this.store.dispatch(new NewsComplaintStateActions.LoadNewCount());
  }
}
